import {
  FaBell,
  FaSearch,
  FaUserCircle,
  FaSignOutAlt
} from "react-icons/fa";

import { useState } from "react";

import { useNavigate } from "react-router-dom";

import "./Header.css";

const Header = () => {

  const navigate =
    useNavigate();

  const [showMenu, setShowMenu] =
    useState(false);

  const logout = () => {

    localStorage.clear();

    navigate("/");

  };

  const today =
    new Date().toLocaleDateString(
      "en-IN",
      {
        day: "2-digit",
        month: "short",
        year: "numeric"
      }
    );

  return (

    <header className="erp-header">

      {/* Left */}

      <div className="header-left">

        <div>

          <h4 className="page-title">
            Dashboard
          </h4>

          <span className="page-subtitle">
            Welcome back to PaperStock ERP
          </span>

        </div>

      </div>

      {/* Center */}

      <div className="header-center">

        <div className="search-box">

          <FaSearch />

          <input
            type="text"
            placeholder="Search..."
          />

        </div>

      </div>

      {/* Right */}

      <div className="header-right">

        <div className="current-date">

          {today}

        </div>

        <button
          className="icon-btn"
          type="button"
        >

          <FaBell />

          <span
            className="notification-dot"
          ></span>

        </button>

        <div
          className="profile-dropdown"
        >

          <button
            className="profile-btn"
            type="button"
            onClick={() =>
              setShowMenu(!showMenu)
            }
          >

            <FaUserCircle />

            <div>

              <strong>
                Admin
              </strong>

              <small>
                Administrator
              </small>

            </div>

          </button>

          {
            showMenu && (

              <div
                className="profile-menu"
              >

                <button
                  className="profile-menu-item"
                  onClick={logout}
                >

                  <FaSignOutAlt />

                  <span>
                    Logout
                  </span>

                </button>

              </div>

            )
          }

        </div>

      </div>

    </header>

  );

};

export default Header;